import template from './floor.jade';

export default angular
    .module('cian.addForm.buildingFloor', [])
    .directive('cianAfAboutBuildingFloor', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller() {
            this.minFloorNumber = -2;
        },
        controllerAs: 'floor',
        template,
    }))
    .name;
